import { render, staticRenderFns } from "./AskResetPassword.vue?vue&type=template&id=4852d611&"
import script from "./AskResetPassword.vue?vue&type=script&lang=js&"
export * from "./AskResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports